import React from 'react';

// بيانات المجموعة
export const COMPANY_INFO = {
  name: 'مجموعة المحامي هشام بن يوسف الخياط',
  subtitle: 'للمحاماة والإستشارات القانونية وخدمات الموثق',
  fullName: 'مجموعة المحامي هشام بن يوسف الخياط للمحاماة والإستشارات القانونية وخدمات الموثق',
  phone: '0597771616',
  email: 'info@alkhayat-law.sa',
  address: 'جدة - حي الحمراء - شارع الشانزلزيه',
  license: 'ترخيص محاماة رقم: 624',
  licenseNumber: '624',
};

/**
 * Logo component for Hisham Al-Khayat Law Firm
 * @param {Object} props
 * @param {string} props.size - Size variant: 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
 * @param {string} props.variant - Logo variant: 'gold' (للخلفيات الداكنة) | 'dark' (للخلفيات الفاتحة)
 * @param {string} props.className - Additional CSS classes
 */
export const Logo = ({ size = 'md', variant = 'gold', className = '' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
    xxl: 'w-24 h-24',
    print: 'w-20 h-20',
  };

  // استخدام الشعار الجديد لموقع hklaw.sa
  const logoSrc = '/hklaw-logo.jpg';

  return (
    <img
      src={logoSrc}
      alt={COMPANY_INFO.fullName}
      className={`${sizeClasses[size]} object-contain rounded ${className}`}
      data-testid="company-logo"
    />
  );
};

/**
 * Company Header component for documents, reports, invoices
 * @param {Object} props
 * @param {string} props.variant - 'light' (خلفية فاتحة) | 'dark' (خلفية داكنة)
 * @param {boolean} props.showContact - Show contact info
 * @param {string} props.documentType - نوع المستند (فاتورة، سند، عرض، تقرير)
 */
export const CompanyHeader = ({ variant = 'light', showContact = true, documentType = '' }) => {
  const isDark = variant === 'dark';
  
  return (
    <div className={`p-4 rounded-lg ${isDark ? 'bg-primary text-white' : 'bg-white border border-gray-200'}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Logo size="xl" variant={isDark ? 'gold' : 'dark'} />
          <div>
            <h1 className={`text-lg font-bold font-heading ${isDark ? 'text-white' : 'text-primary'}`}>
              {COMPANY_INFO.name}
            </h1>
            <p className={`text-sm ${isDark ? 'text-white/80' : 'text-gray-600'}`}>
              {COMPANY_INFO.subtitle}
            </p>
          </div>
        </div>
        {documentType && (
          <div className={`px-4 py-2 rounded-lg ${isDark ? 'bg-gold text-primary' : 'bg-primary text-white'}`}>
            <span className="font-bold">{documentType}</span>
          </div>
        )}
      </div>
      {showContact && (
        <div className={`mt-3 pt-3 border-t ${isDark ? 'border-white/20' : 'border-gray-200'} flex flex-wrap gap-4 text-sm`}>
          <span className="flex items-center gap-1">
            <span className={isDark ? 'text-gold' : 'text-primary'}>📞</span>
            {COMPANY_INFO.phone}
          </span>
          <span className="flex items-center gap-1">
            <span className={isDark ? 'text-gold' : 'text-primary'}>📧</span>
            {COMPANY_INFO.email}
          </span>
          <span className="flex items-center gap-1">
            <span className={isDark ? 'text-gold' : 'text-primary'}>📍</span>
            {COMPANY_INFO.address}
          </span>
        </div>
      )}
    </div>
  );
};

/**
 * Print Header for PDF/Print documents
 */
export const PrintHeader = ({ documentType = '', documentNumber = '', documentDate = '' }) => {
  return (
    <div className="print-header border-b-2 border-primary pb-4 mb-6">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-4">
          <img src="/hklaw-logo.jpg" alt={COMPANY_INFO.fullName} className="w-20 h-20 object-contain" />
          <div>
            <h1 className="text-xl font-bold text-primary">{COMPANY_INFO.name}</h1>
            <p className="text-sm text-gray-600">{COMPANY_INFO.subtitle}</p>
            <div className="mt-2 text-xs text-gray-500 space-y-1">
              <p>هاتف: {COMPANY_INFO.phone}</p>
              <p>البريد: {COMPANY_INFO.email}</p>
            </div>
          </div>
        </div>
        <div className="text-left">
          {documentType && (
            <div className="bg-primary text-white px-4 py-2 rounded-lg mb-2">
              <span className="font-bold text-lg">{documentType}</span>
            </div>
          )}
          {documentNumber && (
            <p className="text-sm text-gray-600">رقم: <span className="font-bold">{documentNumber}</span></p>
          )}
          {documentDate && (
            <p className="text-sm text-gray-600">التاريخ: <span className="font-bold">{documentDate}</span></p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Logo;
